import { FormData } from '../ContactForm';

export const enum PayloadAction {
  VIEW = 'VIEW',
  ADD_TO_CART = 'ADD_TO_CART',
  BOOK_SERVICE = 'BOOK_SERVICE',
}

export type PayloadCmpProps = {
  payloadId?: string;
  isSmall?: boolean;
  hasSpecialContainer?: boolean; // like gallery for several products
  actions?: PayloadAction[];
  isMultiple?: boolean;
  isProductsWithOneSitePage?: boolean;
};

export interface GenericPayload {
  type: string;
  id: string;
  actions?: PayloadAction[];
}

// // Anything that's not supported
export type OtherPayload = GenericPayload & {
  title?: string;
  subtitle?: string;
  description?: string;
  img?: string;
  url?: string;
  price?: string;
};

export type FormSubmissionPayload = Omit<GenericPayload, 'id' | 'type'> &
  Pick<FormData, 'email' | 'name' | 'phone'> & {
    type: 'form_submitted';
    contactId?: string;
  };
